import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserWebAiChatsQueryVariables = Types.Exact<{
  loggedUserId: Types.Scalars['String']['input'];
}>;


export type GetUserWebAiChatsQuery = { __typename?: 'query_root', webAiChats: Array<{ __typename?: 'webAiChats', id: any, aiChatId: string, partitionId?: string | null, organizationId?: string | null, createdAt?: any | null, starterMessage?: string | null, userId: string, workspaceId?: number | null, user?: { __typename?: 'users', id: string, firstName: string, lastName: string, profilePhotoLink?: string | null } | null, workspace?: { __typename?: 'workspaces', id: number, name: string, logo?: string | null } | null }> };


export const GetUserWebAiChatsDocument = gql`
    query getUserWebAiChats($loggedUserId: String!) {
  webAiChats(where: {userId: {_eq: $loggedUserId}}, order_by: {createdAt: desc}) {
    id
    aiChatId
    partitionId
    organizationId
    createdAt
    starterMessage
    userId
    user {
      id
      firstName
      lastName
      profilePhotoLink
    }
    workspaceId
    workspace {
      id
      name
      logo
    }
  }
}
    `;

/**
 * __useGetUserWebAiChatsQuery__
 *
 * To run a query within a React component, call `useGetUserWebAiChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWebAiChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWebAiChatsQuery({
 *   variables: {
 *      loggedUserId: // value for 'loggedUserId'
 *   },
 * });
 */
export function useGetUserWebAiChatsQuery(baseOptions: Apollo.QueryHookOptions<GetUserWebAiChatsQuery, GetUserWebAiChatsQueryVariables> & ({ variables: GetUserWebAiChatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserWebAiChatsQuery, GetUserWebAiChatsQueryVariables>(GetUserWebAiChatsDocument, options);
      }
export function useGetUserWebAiChatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserWebAiChatsQuery, GetUserWebAiChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserWebAiChatsQuery, GetUserWebAiChatsQueryVariables>(GetUserWebAiChatsDocument, options);
        }
export function useGetUserWebAiChatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserWebAiChatsQuery, GetUserWebAiChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserWebAiChatsQuery, GetUserWebAiChatsQueryVariables>(GetUserWebAiChatsDocument, options);
        }
export type GetUserWebAiChatsQueryHookResult = ReturnType<typeof useGetUserWebAiChatsQuery>;
export type GetUserWebAiChatsLazyQueryHookResult = ReturnType<typeof useGetUserWebAiChatsLazyQuery>;
export type GetUserWebAiChatsSuspenseQueryHookResult = ReturnType<typeof useGetUserWebAiChatsSuspenseQuery>;
export type GetUserWebAiChatsQueryResult = Apollo.QueryResult<GetUserWebAiChatsQuery, GetUserWebAiChatsQueryVariables>;